/**
 * Created by intellicar-rinas on 4/10/17.
 */
import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import {
  flipRange,
  canShowRangeSwitch,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
// import mixpanel from "mixpanel-browser";
import actions from "../../../store/actions";

let _dateFormat = dateFormat + ":ss";
let refreshTableReq;

const refreshTable = (schema, data, store) => {
  if (data.vehicle && data.vehicle.length) {
    clearTimeout(refreshTableReq);
    refreshTableReq = setTimeout(() => {
      if (!schema.rawResp) return;

      let filteredData = [];
      let limit = parseInt(data.limit);

      for (let idx in schema.rawResp) {
        if (schema.rawResp[idx].speed > limit) {
          filteredData.push(schema.rawResp[idx]);
        }
      }
      setTableValues(schema, data, filteredData);
    }, 500);
  } else {
    console.log("Please select atleast one vehicle");
  }
};

let saveState = null;
let tableStateData = null;

const setTableValues = (schema, data, resp) => {
  let sortedData = [];
  const handleAddressSuccess = (respAddr) => {
    for (let idx in latLngList) {
      resp[latLngList[idx][2]].address = respAddr[idx][1];
    }
    // this.finalData = resp;
    if (schema.content[0].ref) {
      if (data.limit === 0 || data.limit == null) {
        schema.content[0].ref.setData(resp);
      }
      if (data.limit > 0) {
        for (let idx in resp) {
          if (resp[idx].speed >= data.limit) {
            sortedData.push(resp[idx]);
          }
        }
        schema.content[0].ref.setData(sortedData);
      }
    }
  };

  const handleAddressFailure = (resp) => {};

  let isAddressRequired = true;
  let latLngList = [];
  let lastLatLngPushTime = null;
  let ignitionStatus = true;
  let forceAdd = false;
  for (let idx in resp) {
    resp[idx].ignition = resp[idx].ignstatus ? "On" : "Off";
    resp[idx].address = resp[idx].latitude + "," + resp[idx].longitude;
    resp[idx].latLngArr = [resp[idx].latitude, resp[idx].longitude];
    if (!ignitionStatus && (resp[idx].ignstatus || resp[idx].speed > 5)) {
      ignitionStatus = true;
      forceAdd = true;
    }
    if (isAddressRequired) {
      if (lastLatLngPushTime === null) {
        lastLatLngPushTime = resp[idx].time;
      }
      if (
        forceAdd ||
        resp[idx].time === lastLatLngPushTime ||
        resp[idx].time - lastLatLngPushTime > 1000 * 60 * 10
      ) {
        latLngList.push([resp[idx].latitude, resp[idx].longitude, idx]);
        lastLatLngPushTime = resp[idx].time;
      }
      ignitionStatus = resp[idx].ignstatus;
      forceAdd = false;
    }
  }
  // if (isAddressRequired) {
  //   GeoCodeAPIs.getAddress(latLngList).then(
  //     handleAddressSuccess,
  //     handleAddressFailure
  //   );
  // }
  // this.finalData = resp;
  if (tableStateData && tableStateData[0]) {
    tableStateData[0].body = data;
    tableStateData[0].busy = false;
    saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
  }
  if (schema.content[0].ref) {
    schema.content[0].ref.setData(resp);
  }
};

const getHistory = (schema, data, store) => {
  // console.log("data",schema)
  // mixpanel.track("User Looks For GPS Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  // this.finalData = null;
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  if (starttime > endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (endtime - starttime > 1000 * 60 * 60 * 24 * 35) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 35 days",
        content: "You can't select date range of more than 35 days",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    const handleSuccess = (resp) => {
      window.dataForAll = resp;
      schema.rawResp = resp;
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      setTableValues(schema, data, resp);
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    let body = {
      vehicleid: data.vehicle[0].data.vehicleid,
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
    };
    if (window.showNoGpsFixData === true) {
      body.fixqfilter = false;
    }
    ReportAPIs.getRTGPS(body).then(handleSuccess, (r) => {
      handleSuccess([]);
    });
  } else {
    window.graphDataErr = "";
    console.log("inside else");
    window.dataForAll = null;
    window.graphDataErr = "Please Select Vehicle";
    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    // window.dispatchStoreEvent({
    //   type: actions.GRAPHSET_STATE_CHANGED,
    //   data: 0,
    // });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
};

const isHeadShowable = (vehicles) => {
  if (vehicles && vehicles[0] && vehicles[0].data) {
    let vehicle = vehicles[0].data;
    let devices = [];
    for (let idx in vehicle.devices) {
      devices.push(vehicle.devices[idx].devicetype);
    }
    return (
      devices.indexOf("concox_assettracker") === -1 ||
      devices.indexOf("concox_at4") === -1
    );
  }
  return true;
};

const downloadReport = (schema) => {
  // mixpanel.track("User Downloads GPS Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  if (schema.content[0].ref) {
    JSONToCSVConvertor(
      schema.content[0].ref.getData(true),
      "GPS Report",
      false
    );
  }
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[5].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});

const schema = {
  key: "gps_report",
  name: "GPS Report",
  rawResp: null,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      singleSelect: true,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "limit",
      type: schemaTypes.INPUT_NUMBER,
      placeholder: "Filter by GPS speed",
      model: 0,
      onChange: refreshTable,
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get GPS Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: downloadReport,
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "time", name: "Time", type: "DATE", format: _dateFormat },
        // { key: "odometer", name: "Odometer", isShowable: isHeadShowable },
        { key: "speed", name: "Speed" },
        { key: "devbattery", name: "Device Battery" },
        { key: "carbattery", name: "Car Battery" },
        { key: "ignition", name: "Ignition", isShowable: isHeadShowable },
        // {key:'latlng', name:'Lat Lng'},
        {
          key: "address",
          name: "Address",
          width: 3,
          onClick: (d, item) => {
            window.showInGoogleMaps(item.latLngArr[0], item.latLngArr[1]);
          },
        },
      ],
    },
  ],
};

export default schema;
